import { DuplicateId } from "./DuplicateId";
import { AutogenLayoutCallinStatus } from "./autogen/AutogenLayoutCallinStatus";

export class CallinStatus extends AutogenLayoutCallinStatus {
    onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "callin_status",
            screenName: "Callin Status",
            navigateToUrl: "lme/dispatch/CallinStatusList",
            listLayout: true
        });
    }
}
